
const translations = {
  es: {
    titleCreate: "Nuevo Servicio",
    titleEdit: "Editar Servicio",
    name: "Nombre del servicio",
    description: "Descripción",
    maxCapacity: "Capacidad máxima",
    category: "Categoría",
    price: "Precio (₡)",
    active: "Servicio activo",
    submitCreate: "Crear Servicio",
    submitEdit: "Actualizar Servicio",
    creating: "Creando...",
    updating: "Actualizando...",
    requiredName: "El nombre es obligatorio",
    requiredCategory: "La categoría es obligatoria",
    requiredDescription: "La descripción es obligatoria",
    invalidCapacity: "Capacidad máxima debe ser un número ≥ 1",
    invalidPrice: "El precio debe ser un número ≥ 0",
    priceRequired: "El precio es obligatorio",
    unknownError: "Error desconocido",
    saved: "Guardado correctamente",
    cannotUpdateDueToReservations: "No se puede editar el servicio debido a que tiene reservaciones activas",
    cannotDeleteDueToReservations: "No se puede eliminar el servicio debido a que tiene reservaciones activas",
    operationError: "Error en la operación",
    image: "Imagen del servicio (opcional)",
    image_error:"Error al subir imagen"
  },
  en: {
    titleCreate: "New Service",
    titleEdit: "Edit Service",
    name: "Service Name",
    description: "Description",
    maxCapacity: "Max Capacity",
    category: "Category",
    price: "Price (₡)",
    active: "Service active",
    submitCreate: "Create Service",
    submitEdit: "Update Service",
    creating: "Creating...",
    updating: "Updating...",
    requiredName: "Name is required",
    requiredCategory: "Category is required",
    requiredDescription: "Description is required",
    invalidCapacity: "Max capacity must be a number ≥ 1",
    invalidPrice: "Price must be a number ≥ 0",
    priceRequired: "Price is required",
    unknownError: "Unknown error",
    saved: "Saved successfully",
    cannotUpdateDueToReservations: "Cannot edit service due to active reservations",
    cannotDeleteDueToReservations: "Cannot delete service due to active reservations",
    operationError: "Operation error",
    image: "Service image (optional)",
    image_error:"Error to upload image"
  },
};
export default translations